import React, { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const CHOICES = ["rock", "paper", "scissors"];
const EMOJI = { rock: "✊", paper: "✋", scissors: "✌" };

function judge(a, b) {
  if (a === b) return "draw";
  if ((a === "rock" && b === "scissors") || (a === "paper" && b === "rock") || (a === "scissors" && b === "paper")) return "you";
  return "cpu";
}

export default function RPS() {
  const [you, setYou] = useState(null);
  const [cpu, setCpu] = useState(null);
  const [result, setResult] = useState(null);
  const [score, setScore] = useState({ you: 0, cpu: 0 });
  const { refreshMe } = useAuth();

  const play = async (choice) => {
    const c = CHOICES[Math.floor(Math.random() * 3)];
    const r = judge(choice, c);
    setYou(choice); setCpu(c); setResult(r);
    if (r === "you") {
      setScore(s => ({ ...s, you: s.you + 1 }));
      try { await api.post("/games/result", { game_slug: "rps", won: true }); refreshMe(); } catch {}
    } else if (r === "cpu") {
      setScore(s => ({ ...s, cpu: s.cpu + 1 }));
    }
  };
  const reset = () => { setYou(null); setCpu(null); setResult(null); setScore({ you: 0, cpu: 0 }); };

  return (
    <div data-testid="game-rps" className="bg-black/60 border border-white/10 rounded-md p-6 max-w-md mx-auto text-center">
      <div className="sc-heading text-2xl font-bold mb-2">Rock · Paper · Scissors</div>
      <div className="text-xs text-zinc-400 mb-6">vs House · free play</div>
      <div className="grid grid-cols-3 gap-6 mb-8 text-7xl">
        <div>
          <div className="opacity-60 text-xs mb-2 sc-label">You</div>
          <div className={result === "you" ? "text-[#10B981]" : ""}>{you ? EMOJI[you] : "❔"}</div>
        </div>
        <div className="text-2xl flex items-center justify-center text-zinc-500">
          {result === "draw" ? "=" : result ? "vs" : ""}
        </div>
        <div>
          <div className="opacity-60 text-xs mb-2 sc-label">House</div>
          <div className={result === "cpu" ? "text-[#FF3366]" : ""}>{cpu ? EMOJI[cpu] : "❔"}</div>
        </div>
      </div>
      {result && (
        <div className="text-lg font-bold mb-4" style={{ color: result === "you" ? "#10B981" : result === "cpu" ? "#FF3366" : "#F59E0B" }}>
          {result === "you" ? "You win! +25 credits" : result === "cpu" ? "House wins" : "Draw"}
        </div>
      )}
      <div className="flex gap-2 justify-center mb-4">
        {CHOICES.map(c => (
          <button key={c} data-testid={`rps-${c}`} onClick={() => play(c)} className="sc-btn-ghost text-2xl px-4 py-3">{EMOJI[c]}</button>
        ))}
      </div>
      <div className="text-xs text-zinc-400">You: {score.you} · House: {score.cpu}</div>
      <button onClick={reset} className="sc-btn-ghost text-xs mt-3">Reset</button>
    </div>
  );
}
